import { css } from '@linaria/atomic';
import { useTranslation } from '@frontend/i18n';
import { Button } from '../../../button/button.component';
import { styles } from './date-navigator.styles';
import { DateNavigatorWrapperProps } from './date-navigator.types';

const dateNavigatorWrapperDivStyle1 = css`
  position: relative;
`;

export const DateNavigatorWrapper = ({
  children,
  showNavigationButtons,
  navigationButtonHoverLabel,
  trackingIds,
  handleNavigation,
}: DateNavigatorWrapperProps & { children: React.ReactNode }) => {
  const { t } = useTranslation();

  return (
    <div className={styles.navigatorContainer}>
      {showNavigationButtons && (
        <Button
          variant='secondary'
          size='small'
          iconName='caret-left'
          className={styles.navigationButton}
          trackingId={trackingIds?.prevButton}
          hoverLabel={navigationButtonHoverLabel?.prev || t('Previous Day')}
          onClick={() => handleNavigation(-1)}
        />
      )}
      <div className={dateNavigatorWrapperDivStyle1}>{children}</div>
      {showNavigationButtons && (
        <Button
          variant='secondary'
          size='small'
          iconName='caret-right'
          className={styles.navigationButton}
          trackingId={trackingIds?.nextButton}
          hoverLabel={navigationButtonHoverLabel?.next || t('Next Day')}
          onClick={() => handleNavigation(1)}
        />
      )}
    </div>
  );
};
